import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StadiumEventsStudentResponse {
  stadium_events_counts_summary: {
    data: [
      {
        category: 'total_count'
        count: number
      },
    ]
  }
  stadium_events_counts: { event_type: 'spelling' | 'grammar' | 'vocabulary' | 'usage'; count: number }[]
}

export interface StadiumEventsStudentData {
  summary: {
    total_count: number
  }
  events: {
    spelling: number
    grammar: number
    vocabulary: number
    usage: number
  }
}

export async function stadiumEventsStudent(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: StudentsScope,
  period: NormalizedInterval,
) {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('stadium_events_counts', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StadiumEventsStudentResponse>(url, query)
  if (!data) return null

  const { stadium_events_counts_summary, stadium_events_counts } = data
  if (stadium_events_counts.length === 0) return null

  const total_count = stadium_events_counts_summary.data.find((data) => data.category === 'total_count')!.count
  const spelling = stadium_events_counts.find((data) => data.event_type === 'spelling')?.count ?? 0
  const grammar = stadium_events_counts.find((data) => data.event_type === 'grammar')?.count ?? 0
  const vocabulary = stadium_events_counts.find((data) => data.event_type === 'vocabulary')?.count ?? 0
  const usage = stadium_events_counts.find((data) => data.event_type === 'usage')?.count ?? 0

  return {
    summary: {
      total_count,
    },
    events: {
      spelling,
      grammar,
      vocabulary,
      usage,
    },
  }
}
